import './brokerCryptoTestContainer.scss'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { taggingEventHandled } from 'utilities/taggingEventHandled';
import { PROC_BROKER_CONVENIENCE_CRYPTO_TEST } from 'utilities/tagging';
import { ANWSER_SELECTED_STATUS } from 'mifid/constants/constants';

import BrokerConvenienceMiFIDTestActions from 'mifid/actions/brokerConvenienceMiFIDTest';
import { CryptoNavigationCard } from 'mifid/components/brokerCryptoTest/brokerCryptoNavigationCard/brokerCryptoNavigationCard'

export const BrokerCryptoTestContainer = ({ immBrokerConvenienceMiFIDTest, immTestQuestion, currentQuestionIndex, onClickAnswer}) => {

    const handleClickRadioButton = (immCurrentQuestion, answer) => {
        onClickAnswer(immCurrentQuestion.get('id'), answer.get('id'))
        taggingEventHandled(PROC_BROKER_CONVENIENCE_CRYPTO_TEST, 'selectOption', {
            component: immCurrentQuestion.get('componentTag'),
            element: answer.get('id'),
        });
    }

    const buildQuestion = () => {
        const immCurrentQuestion = immTestQuestion.get(currentQuestionIndex);
        const description = immCurrentQuestion.get('description');
        const immAnswer = immCurrentQuestion.get('answer');
        return (
            <div className="crypto-test-container__question">
                <h2 className="crypto-test-container__question-title">{description}</h2>
                <div className="crypto-test-container__question-answers">
                    {immAnswer.map((answer, index) => {
                        const answerDescription = answer.get('description');
                        const answerDetails = answer.get('details');
                        return (
                            <div className="crypto-test-container__question-answer">
                                <CryptoNavigationCard
                                    id={answer.get('id')}
                                    isSelected={answer.get('selected') === ANWSER_SELECTED_STATUS}
                                    key={index}
                                    title={answerDescription}
                                    description={answerDetails}
                                    onClick={() => handleClickRadioButton(immCurrentQuestion, answer)}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        );

    }

    if (immTestQuestion && immTestQuestion.size > 0) {
        return (
            <div className="crypto-test-container__container">
                { buildQuestion() }
            </div>
        );
    } else {
        return null;
    }
}

BrokerCryptoTestContainer.propTypes = {
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    immTestQuestion: PropTypes.object.isRequired,
    currentQuestionIndex: PropTypes.number.isRequired,
    onClickAnswer: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
    immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
})

const mapDispatchToProps = {
    handleNextStep: BrokerConvenienceMiFIDTestActions.goToForwardStep,
    handlePreviousStep: BrokerConvenienceMiFIDTestActions.goToPreviousStep,
}

export default connect(mapStateToProps, mapDispatchToProps)(BrokerCryptoTestContainer)